"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPercentage = void 0;
/**
 * Returns the percentage based on the provided data, if maxScore is 0 it returns 0
 * @param {number}            score      - score
 * @param {number}            maxScore   - max Score
 *
 * @return percentage number
 */
var getPercentage = function (averageScore, maxScore) {
    if (averageScore === void 0) { averageScore = 0; }
    if (maxScore === void 0) { maxScore = 0; }
    return maxScore ? (averageScore / maxScore) * 100 : 0;
};
exports.getPercentage = getPercentage;
